import { render, staticRenderFns } from "./ChipColor.vue?vue&type=template&id=3b28e628"
import script from "./ChipColor.vue?vue&type=script&lang=js"
export * from "./ChipColor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports